import { render } from "./InvoicesPage.vue?vue&type=template&id=353aea66&scoped=true"
import script from "./InvoicesPage.vue?vue&type=script&lang=js"
export * from "./InvoicesPage.vue?vue&type=script&lang=js"

import "./InvoicesPage.vue?vue&type=style&index=0&id=353aea66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353aea66"]])

export default __exports__